module.exports = __webpack_public_path__ + "static/media/aquatuur-interreg-vn-vertical.65bcdef2.png";